import { render } from "./DealerItemDesktop.vue?vue&type=template&id=23f24c14&scoped=true"
import script from "./DealerItemDesktop.vue?vue&type=script&lang=js"
export * from "./DealerItemDesktop.vue?vue&type=script&lang=js"

import "./DealerItemDesktop.vue?vue&type=style&index=0&id=23f24c14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f24c14"]])

export default __exports__